import FilePresent from "@mui/icons-material/FilePresent";
import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import PictureAsPdfOutlined from "@mui/icons-material/PictureAsPdfOutlined";
import { LighterTinyText, Text, TextUnderlined, TinyText } from "./HXDesktopPage.styles";
import { HXSimpleDialog } from "./HXSimpleDialog";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import { TranscodeStatus } from "healthex-common/transcode.dtos";
export const FileUploadParent = styled(FlexColumn) `
    gap: 4px;
`;
export const FileUploadDashedContainer = styled.div `
    border-radius: 4px;
    border: 2px dashed ${(props) => (props.fileHovering ? colors.black_30 : colors.black_12)};
    background: ${(props) => (props.error ? colors.tulip_8 : colors.white_background)};
    position: relative;
    align-self: stretch;

    ${(props) => props.height &&
    css `
            height: ${props.height}px;
        `}

    ${(props) => props.requiredError &&
    css `
            border-color: ${colors.tulip_main};
        `}
`;
export const FileUploadMessageContainer = styled(FlexRow) `
    gap: 4px;
    align-items: center;
`;
export const PreviewImageWrapper = styled.div `
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ disabled }) => disabled &&
    `
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.7);
            z-index: 1;
        }
    `}
`;
export const PreviewImage = styled.img `
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
`;
export const UploadPreview = styled(FlexColumnDiv) `
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 16px;
    position: relative;
    ${(props) => props.disabled &&
    css `
            color: ${colors.black_30};
        `}

    & .MuiIconButton-root {
        position: absolute;
        top: 4px;
        right: 4px;
        border: 1px solid ${colors.navy_50};
        padding: 5px;
        display: none;
        z-index: 2;
    }

    &:hover .MuiIconButton-root {
        display: inline-flex;
    }

    & .MuiSvgIcon-root {
        ${(props) => props.disabled &&
    css `
                color: ${colors.black_30};
            `}
    }
`;
export const FileUploadingContainer = styled(FlexColumn) `
    background: ${(props) => (props.disabled ? colors.navy_4 : colors.navy_8)};
    width: 100%;
    height: 100%;
    gap: 16px;
    align-items: center;
    justify-content: center;
`;
export const FileUploadingProgressContainer = styled.div `
    position: relative;
    z-index: 0;
    width: 50px;
    height: 50px;
`;
export const FileUploadingCircularProgress = styled(CircularProgress).attrs({ variant: "determinate" }) `
    position: absolute;
    width: 50px;
    max-width: 50px;
    min-width: 50px;
    height: 50px;
    max-height: 50px;
    min-height: 50px;
    top: 0;
    left: 0;
    z-index: 1;
    color: ${(props) => (props.disabled ? colors.navy_30 : colors.navy_main)};
`;
export const FileUploadingProgressText = styled(LighterTinyText) `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
`;
export const UploadInput = styled(FlexColumnDiv) `
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 16px;
    justify-content: center;
    align-items: center;
    gap: 16px;
`;
export const FileName = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
    overflow-wrap: anywhere;
    font-size: ${fontSizes.MEDIUM};
`;
export const FileButtons = styled(FlexRowDiv) `
    justify-content: center;
    align-items: center;
    margin-top: 8px;
`;
export const FileDot = styled(TinyText) `
    padding: 0 8px;
    color: ${colors.black_lighter};
`;
const iconCSS = css `
    width: 24px;
    height: 24px;
`;
export const FileNameIcon = styled(FilePresent) `
    ${iconCSS}
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_lighter)};
`;
export const PdfIcon = styled(PictureAsPdfOutlined) `
    ${iconCSS}
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_lighter)};
`;
export const FilePreviewDialog = styled((HXSimpleDialog)) `
    & .MuiPaper-root {
        width: calc(100% - 64px);
        max-height: calc(100% - 64px);
        max-width: 2000px;
        margin: 0;
        padding: 0;
    }

    & .MuiDialogContent-root > * {
        width: 100%;
    }
`;
export const DragLeaveDetector = styled.div `
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
`;
export const ButtonAndDropText = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
    justify-content: center;
`;
export const TypeAndSize = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_lighter)};
    font-size: ${fontSizes.TINY};
`;
export const ErrorIcon = styled(ErrorOutline) `
    color: ${colors.tulip_main};
    width: 32px;
    height: 32px;
`;
export const ErrorTryAgain = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
`;
export const ErrorMessage = styled.div `
    color: ${colors.tulip_main};
`;
export const UploadTipsContainer = styled.div `
    & ul {
        margin-top: 0;
        padding-left: 24px;

        & li {
            padding-left: 4px;
        }

        ${(props) => props.disabled &&
    css `
                & li::marker {
                    color: ${colors.black_30};
                }
            `}

        ${(props) => props.color &&
    css `
                & li::marker {
                    color: ${props.color};
                }
            `}
    }
`;
export const VideoHintLink = styled(TextUnderlined) `
    display: inline-block;
`;
export const LearnMoreText = styled(Text) `
    padding: 0 24px 20px 24px;
`;
export const FileUploadVideoCircularProgress = styled(CircularProgress) `
    color: ${(props) => (props.disabled ? colors.black_30 : colors.black_main)};
    width: 16px;
    max-width: 16px;
    min-width: 16px;
    height: 16px;
    max-height: 16px;
    min-height: 16px;
    margin-right: 4px;
`;
export const FileUploadVideoCheckCircleOutlinedIcon = styled(CheckCircleOutlined) `
    width: 16px;
    height: 16px;
    color: ${colors.forest_main};
`;
export const FileUploadVideoText = styled(TinyText) `
    color: ${colors.black_lighter};

    ${(props) => props.status === TranscodeStatus.FAILED &&
    css `
            color: ${colors.tulip_main};
        `}

    ${(props) => props.status === TranscodeStatus.COMPLETED &&
    props.isLocalVideo &&
    css `
            color: ${colors.forest_main};
        `}
`;
